import set from 'lodash/set'

import { deepCopy } from '@/utils/object'

import { type SalesEditorTemplate } from './state/types'

export const mergeChangesWithTemplate = (
  templateData: SalesEditorTemplate['data'],
  currentChanges: SalesEditorTemplate['data'],
) => {
  const templateDataClone = deepCopy(templateData)

  for (const [dateRange, changes] of Object.entries(currentChanges)) {
    Object.entries(changes).forEach(([key, value]) => {
      if (value && typeof value === 'object') {
        Object.entries(value).forEach(([childKey, childValue]) => {
          set(templateDataClone, `${dateRange}.${key}.${childKey}`, childValue)
        })
      } else {
        set(templateDataClone, `${dateRange}.${key}`, value)
      }
    })
  }

  return templateDataClone
}
